import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ProductService } from '../../../../core/services/product.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  list: any[] = [];
  filterList: any[] = [];
  pageList: any[] = [];
  sortByList: any[] = [];
  selectedSort: string = "id";
  sortBy: string = "asc";
  viewList: any[] = [];
  selectedView: number = 4;
  productList: any[] = [];
  isLoading: boolean = false;

  page = 1;
  pageSize = 12;
  selectPageSize: number = 12;
  collectionSize = 0;
  searchText: string = "";

  result: string = "";

  @Output() selectedProduct = new EventEmitter<any>();
  @Input() isFromModal = false;
  constructor(private _productService: ProductService) { }

  ngOnInit(): void {
    this.list = [
      { id: 1, name: "Test1" },
      { id: 2, name: "Test2" },
      { id: 3, name: "Test3" },
    ]
    this.filterList = [
      { id: 1, key: "brands", name: "Brands", isShow: false },
      { id: 2, key: "collection", name: "Collection", isShow: false },
      { id: 3, key: "type", name: "Type", isShow: false },
      { id: 4, key: "finish", name: "Finish", isShow: false },
      { id: 5, key: "style", name: "Style", isShow: false },
      { id: 6, key: "color", name: "Color", isShow: false },
      { id: 7, key: "width", name: "Width", isShow: false },
      { id: 8, key: "rabbet", name: "Rabbet", isShow: false },
      { id: 9, key: "height", name: "Height", isShow: false },
    ]
    this.pageList = [
      { id: 1, name: 12 },
      { id: 2, name: 24 },
      { id: 3, name: 32 },
    ]
    this.sortByList = [
      { name: "Brand", sortName: "ProductCategory" },
      { name: "Collection", sortName: "Collection" },
      { name: "Type", sortName: "Type" },
      { name: "Finish", sortName: "Finish" },
      { name: "Style", sortName: "Style" },
      { name: "Color", sortName: "Color" },
    ]
    this.viewList = [
      { id: 2, url: "../../../../../assets/images/View-2.JPG" },
      { id: 3, url: "../../../../../assets/images/View-3.JPG" },
      { id: 4, url: "../../../../../assets/images/View-4.JPG" },
      //{ id: 5,  url: "../../../../../assets/images/View-5.JPG" },
      { id: 1, url: "../../../../../assets/images/View-Other.JPG" },
    ];
    this.getProducts();
    this.getFilters();
  }

  getProducts() {
    this.isLoading = true;
    let skip = (this.page - 1) * this.pageSize;
    let model = {
      skip: skip, take: this.pageSize, searchString: this.searchText, sort: this.selectedSort, sortBy: this.sortBy,
      filters: this.selectedFilters()
    };
    this._productService.getProductsPaginated(model).pipe(take(1)).subscribe(response => {
      if (response?.value?.data?.records) {
        this.productList = response.value.data.records.map(r => {
          r.imageShow = false;
          return r;
        });
        this.collectionSize = response.value.data.total;
        this.result = this.page == 1 ? `${this.page} - ${this.productList.length}` : `${(this.page * this.pageSize) + 1} - ${(this.page * this.pageSize) + this.productList.length}`;
        this.isLoading = false;
      }
    });

  }
  getFilters() {
    this._productService.getFilters().pipe(take(1)).subscribe(response => {
      if (response?.value?.data) {
        console.log(response)
        let data = response.value.data;
        for (let filter of this.filterList) {
          filter.selection = [];
          if (data[filter.key] && Array.isArray(data[filter.key])) {
            filter.selection = data[filter.key].map((s, index) => {
              let obj: any = {};
              obj.isChecked = false;
              obj.id = index;
              obj.name = s;
              return obj;
            });
          }
        }
        //console.log(this.filterList);
      }
    });
  }
  reset() {
    this.page = 1;
    this.sortBy = "asc";
    this.searchText = "";

    for (let filter of this.filterList) {
      if (filter.selection) {
        for (let item of filter.selection) {
          item.isChecked = false;
        }
      }
    }
    this.getProducts();
  }
  search() {
    this.page = 1;
    this.getProducts();
  }
  sort() {
    this.sortBy = this.sortBy == "asc" ? "desc" : "asc";
    this.page = 1;
    this.getProducts();
  }
  changePageSize() {
    this.pageSize = this.selectPageSize;
    this.page = 1;
    this.getProducts();
  }
  triggerFilter() {
    this.page = 1;
    this.getProducts()
  }
  selectedFilters(): any {
    let filters: any = {};
    for (let item of this.filterList) {
      if (item.selection) {
        let selectionFiltered = item.selection.filter(f => f.isChecked == true).map(m => m.name);
        if (selectionFiltered.length > 0) {
          filters[item.key] = selectionFiltered;
        }
      }
    }
    return filters;
  }
  toggleFilter(id: number): void {
    for (let filter of this.filterList) {
      if (filter.id == id) {
        filter.isShow = !filter.isShow;
        //if (filter.isShow)
        //  filter.isOpenAlready = true;
        break;
      }
    }
  }
  onClickThumbnail(item: any) {
    this.selectedProduct.emit(item);
  }
}
